import React, { useState } from "react";
import { Send } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

const KINDS = [
  { key: "idea",   label: "Idea",   blurb: "A feature, a flow, a wish" },
  { key: "bug",    label: "Bug",    blurb: "Something broken or confusing" },
  { key: "praise", label: "Praise", blurb: "What's working for you" },
  { key: "other",  label: "Other",  blurb: "Anything else" },
];

export default function FeedbackForm() {
  const [kind, setKind] = useState("idea");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const body = message.trim();
    if (!body) return;
    setSubmitting(true);
    try {
      await api.post("/feedback", { kind, message: body });
      setMessage("");
      toast.success("Sent to the archivists. Thank you.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not send.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="feedback-form" className="paper p-6">
      <div className="label mb-4">What kind?</div>
      <div className="flex flex-wrap gap-2 mb-6">
        {KINDS.map((k) => (
          <button
            key={k.key}
            type="button"
            data-testid={`feedback-kind-${k.key}`}
            onClick={() => setKind(k.key)}
            title={k.blurb}
            className={`mono text-[10px] uppercase tracking-[0.18em] px-3 py-1.5 border transition-colors
              ${kind === k.key
                ? "border-[hsl(var(--primary))] text-[hsl(var(--primary))] bg-[hsl(var(--primary)/0.08)]"
                : "border-border text-muted-foreground hover:border-[hsl(var(--primary))] hover:text-foreground"}`}
          >
            {k.label}
          </button>
        ))}
      </div>

      <textarea
        data-testid="feedback-message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows={5}
        maxLength={4000}
        placeholder="Tell us what you're noticing, wishing for, or breaking…"
        className="input-line w-full text-[15px] leading-relaxed resize-none"
      />
      <div className="mt-3 flex items-center justify-between">
        <span className="mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
          {message.length}/4000
        </span>
        <button
          type="submit"
          data-testid="feedback-submit"
          disabled={submitting || !message.trim()}
          className="btn-gold disabled:opacity-40 inline-flex items-center gap-2"
        >
          <Send size={12} />
          {submitting ? "Sending…" : "Send"}
        </button>
      </div>
    </form>
  );
}
